import axios from "axios";
import { API_BASE_URL } from "../../utils/apiBaseUrl";
import { configureAuthInterceptors } from "../../utils/authSession";

const instance = axios.create({
  baseURL: API_BASE_URL,
});

export default configureAuthInterceptors(instance);
